import "../admin/style.css";
import "../admin/custom.css";
import { useEffect, useState, createElement } from "@wordpress/element";
import { createRoot } from "@wordpress/element";
import WidgetApp from "./widget-wrapper";
import NavWidgetApp from "./nav-widget-wrapper";

document.addEventListener("DOMContentLoaded", function () {
	// Mount regular widget
	const mountNode = document.createElement("div");
	mountNode.id = "accessibility-widget-parent";
	document.body.appendChild(mountNode);
	const root = createRoot(mountNode);
	root.render(<WidgetApp />);

	// Mount navigation widget in menu if nav mode is enabled
	const navTarget = document.getElementById("accessibility-widget-nav");
	
	if (navTarget) {
		const navRoot = createRoot(navTarget);
		navRoot.render(<NavWidgetApp />);
	}
});
